










import { Component, Vue } from 'vue-property-decorator';
import ProxyBannerModal from '../Modal/ProxyBannerModal.vue';
import jQuery from 'jquery';

@Component( {
    components: {
        ProxyBannerModal
    }
} )
export default class ProxyBanner extends Vue {
    private jQuery: jQuery = jQuery;

}
